import theme from '../../muiTheme';

const styles = {

    root: {
        '& .MuiTextField-root': {
          margin: theme.spacing(1),
        },
      },
      formContainer: {
        padding: theme.spacing(5),
        transition: '0.3s',
        [theme.breakpoints.down('sm')]: {
          width: '90%'
        }
      },
      form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
      },
      inputField: {
        margin: '5px',
        marginBottom: '20px',
      },
      fileInput: {
        width: '97%',
        margin: '10px 0',
      },
      button: {
        margin: '10px',
        width: 'auto'
      },
      chipInput: {
        minWidth: '100%',
        alignSelf: 'start',
        marginBottom: '30px'
    }

}

export default styles; 